import { createContext } from 'react';
import Store from "../store/store";
import SupplierStore from "../store/supplierStore";

export const StoreContext = createContext<Store>({} as Store);
export const StoreProvider = StoreContext.Provider;

export const SupplierStoreContext = createContext<SupplierStore>({} as SupplierStore);
export const SupplierStoreProvider = SupplierStoreContext.Provider;